import { render, staticRenderFns } from "./AtribuirPerfilDialog.vue?vue&type=template&id=fbf54466"
import script from "./AtribuirPerfilDialog.vue?vue&type=script&lang=js"
export * from "./AtribuirPerfilDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports